import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";

const getSize = (size) => {
  switch (size) {
  case "small":
    return 16;  
  case "large": 
    return 24;
  case "xlarge":
    return 28;
  case "medium":
  default:
    return 20;
  }
};

const SFSpinner = (props) => <CircularProgress {...props} size={getSize(props.size)} />;

SFSpinner.defaultProps = {
  size: "medium"
};

SFSpinner.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large", "xlarge"])
};

export default SFSpinner;
